import { Card, Badge, Group, Text, Stack } from '@mantine/core';
import { PackageItem } from '../../types/package';

interface Props {
    packages: PackageItem[];
    statusColors: Record<string, string>;
    getCardStyle: (isReceived: boolean) => React.CSSProperties;
    getPackageStatus: (isReceived: boolean) => string;
    formatDate: (date: string) => string;
}

export function ExpectedPackagesMobile({
    packages,
    statusColors,
    getCardStyle,
    getPackageStatus,
    formatDate
}: Props) {
    return (
        <Stack gap={8}>
            {packages.map(pkg => {
                const status = getPackageStatus(pkg.isReceived);
                return (
                    <Card
                        key={pkg.id}
                        withBorder
                        radius="lg"
                        p="md"
                        style={{ ...getCardStyle(pkg.isReceived), boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}
                        shadow="md"
                    >
                        <Stack gap={6}>
                            <Group justify="space-between" align="center" mb={2}>
                                <Badge
                                    color={statusColors[status]}
                                    variant="gradient"
                                    gradient={{ from: statusColors[status], to: 'blue', deg: 90 }}
                                    size="md"
                                    styles={{ root: { fontWeight: 600, fontSize: '1rem', padding: '0.4rem 1rem', letterSpacing: '0.03em' } }}
                                >
                                    {status.charAt(0).toUpperCase() + status.slice(1)}
                                </Badge>
                                <Text size="xs" c={pkg.isReceived ? 'gray.6' : 'blue.6'} fw={500}>
                                    {formatDate(pkg.created_at)}
                                </Text>
                            </Group>
                            <Text
                                size="md"
                                fw={600}
                                style={{
                                    wordBreak: 'break-word',
                                    color: pkg.isReceived ? 'var(--mantine-color-gray-6)' : 'var(--mantine-color-dark-6)',
                                    fontFamily: 'Inter, sans-serif',
                                    lineHeight: 1.5
                                }}
                                lineClamp={3}
                            >
                                {pkg.note || "No description provided"}
                            </Text>
                        </Stack>
                    </Card>
                );
            })}
        </Stack>
    );
}
